export default {
  home: 'Home',
  document_title: 'IP PA and Intercom System',
  login_title: 'IP Audio Dispatch System',
  login: 'Login',
  logining: 'Logging in...',
  login_success:'Login success',
  login_fail:'Login fail',
  not_open_fast_login:'Fast login is not open',
  open:'Open',
  close:'Close',
  dispatch: 'Dispatching console',
  setting: 'Settings',
  user_setting: 'Personal Settings',
  full_screen: 'FullScreen',
  logout: 'Logout',
  otherLogin: 'Login from a different location',
  loginError: 'Incorrect username or password',
  systemIsUpgrade: 'The system is being upgraded. Please wait!',
  reLoginTitle: 'Repeat Login',
  reLoginContent: 'The account has been logged in, whether to log out of the previous login and log in.',
  unknown_error: 'Unknown Error',
  update_password: 'Change password',
  old_pass: 'Old password',
  new_pass: 'New password',
  again_pass: 'Confirm Password',
  old_pass_placeHolder: 'Please enter your old password',
  new_pass_placeHolder: 'Please enter you new password',
  again_pass_placeHolder: 'Please enter you new password again',
  password_error: 'Password should be at least 6 characters，Contain both letters and numbers',
  password_error1: 'The old password is wrong',
  password_error2: 'The passwords you entered do not match',
  searchTip: 'Enter keywords to search',
  searchTime: 'Please select a time',
  search: 'Search',
  total: 'Total',
  item: 'Entry(s)',
  sure: 'Confirm',
  cancel: 'Cancel',
  upload: 'Upload',
  collapsed: 'Expand/Collapse',
  exportFile: 'Export',
  importFile: 'Import',
  exportTemp: 'Download Import Template',
  no_data: 'NO DATA',
  conf_displayNum: 'The conference display number is not configured in the system',
  file: 'File ',
  info: ' too large,more than 10M',
  format_err: ' Incorrect format, please select jpg,png or jpeg.',
  operate_success: 'Successful!',
  operate_complete: 'Completed!',
  operate_fail: 'Failed!',
  exten_change: 'The extension status has changed,please log in again.',
  exten_offline: 'Extension not online or busy.',
  success: 'Success',
  fail: 'Failure',
  unknown: 'UnKnown error',
  unsend: 'Not Sent',
  yes: 'Yes',
  no: 'No',
  multiple: 'Multi-select',
  col: 'Column',
  row: 'Row',
  single: 'Single',
  enable: 'Enable',
  disable: 'Disable',
  isNumber: 'Not a number',
  no_select_exten: 'Extension List',
  selected_exten: 'Selected Extensions',
  noData: 'No Data',
  exten: 'Extension Number',
  outLine: 'Outer Line',
  calling_pre: 'Caller ID',
  caller_pre: 'Called ID',
  no_exten_inline: 'No binded extension available.',
  control_busy: 'Binded extension is busy.',
  fileError: 'File format error!',
  server_error: 'Server Error!',
  enter_name: 'Please enter your username',
  enter_password: 'Please enter your password',
  enter_code: 'Please enter validate code',
  name_null: 'Username can not be empty',
  password_null: 'Password can not be empty',
  code_null: 'Validate Code can not be empty',
  code_title: 'Click Refresh Code',
  code_success: 'Validate Code Current',
  code_fail: 'Validate Code Error',
  message_error: 'Message error',
  title: 'IP Audio Dispatch System',
  is_auto_accept: 'Auto answer',
  auto_type: 'Answering method',
  webRtc_auto: 'Default',
  webRtc_audio: 'Audio',
  webRtc_video: 'Video',
  console_video_button:'Video Button',
  video_call: 'Video calls',
  audio_accept: 'Audio',
  audio_call_out: 'Audio',
  video_call_out: 'Video',
  video_accept: 'Video',
  call_tip: 'Incoming call',
  call_type: 'Call method',
  answer_call: 'Answer',
  reject_call: 'Reject',
  call_content: 'Phone:',
  call_content_append: ' called',
  control: 'Console',
  call: 'Call',
  left_mobile: 'Left Phone',
  right_mobile: 'Right Phone',
  inline: 'OnLine',
  offline: 'OffLine',
  talk: 'Calling',
  ring: 'Ringing',
  answer: 'answer',
  handup: 'hangup',
  terminal_number: 'Terminal Number',
  terminal_name: 'Terminal Name',
  terminal_ip: 'Terminal IP',
  callee_queue: 'Calls in Queue',
  caller_queue: 'Current Calls',
  enterqueue: 'Join the Queue',
  leavequeue: 'Leave the Queue',
  conference: 'Conference',
  videoConference: 'Video Conference',
  and: ' and ',
  unanswer: 'Missed Calls',
  unanswer_time: 'Call Time',
  current_area: 'Current Group',
  partition_conf: 'Group Conference',
  partition_pag: 'Group Paging',
  partition_broad: 'Group BroadCast',
  device_station: 'Terminal Groups',
  device_name: 'Terminal Name',
  device_station_small: 'Location',
  device_name_small: 'Name',
  device_dept: 'Assigned Group',
  intercom: 'Intercom',
  hangup: 'Hangup',
  monitor: 'Monitor',
  barge: 'Barge',
  take_over: 'Force Takeover',
  secret: 'Whisper',
  transfer: 'Transfer',
  more_conf: 'Multi Conference',
  more_broad: 'Multi Broadcasting',
  more_pro: 'Multi Paging',
  group_info: 'Group Info',
  only_admin: 'Visible only to administrators',
  all_area: 'All Group',
  private: 'Private',
  sure_ebs: 'Play/Stop ?',
  play: 'Play',
  stop: 'Stop',
  no_bro: 'No Emergency Broadcast Task.',
  stop_bro: 'Emergency broadcast Disabled.',
  Idle: 'Idle',
  Idel: 'Idle',
  Talking: 'Talking',
  Ringing: 'Ringing',
  OffLine: 'OffLine',
  UnKnow: 'UnKnow',
  UnKnown: 'UnKnow',
  Broading: 'Broadcast',
  broadcast: 'Broadcast Task',
  broad_type: 'Broadcast Type',
  time_broad: 'Schedule Task',
  state_broad: 'Status',
  state_exten: 'Terminal Status',
  state_bro: 'Task in progress',
  all_broad: 'All Task',
  music_broad: 'Music Task',
  pro_broad: 'Paging Task',
  word_broad: 'Text Task',
  see_broad: 'Live PA Task',
  outside_broad: 'OutSide Task',
  file_broad: 'File Task',
  offline_broad: 'Offline Task',
  broad_plan: 'Broadcast Scheme',
  broad_log: 'Broadcast Log',
  change_plan: 'Scheme switching',
  music_broad_not_suffix: 'Music',
  pro_broad_not_suffix: 'Page',
  word_broad_not_suffix: 'TXT',
  see_broad_not_suffix: 'Prerecord',
  file_broad_not_suffix: 'File',
  offline_broad_not_suffix: 'Offline',
  broad_pstn: 'Connect Number',
  broad_status: 'Status',
  broad_task: 'Type',
  broad_model: 'Mode',
  broad_time: 'Played Time',
  broad_order: 'Play Mode',
  broad_priority: 'Priority',
  broad_tone: 'Tip',
  broad_volumn: 'Volume',
  broad_pro: 'Progress',
  one_level: 'Super Emergency',
  two_level: 'High',
  three_level: 'Medium',
  four_level: 'Low',
  nostart_status: 'Not Started',
  start_status: 'Start',
  play_status: 'In progress',
  end_status: 'End',
  pause_status: 'Pause',
  sending: 'Assigning',
  send_complete: 'Assigning Completed',
  part_fail: 'Partial failure',
  model_one: 'Instant Broadcast',
  model_two: 'Schedule Broadcast',
  model_three: 'Trigger Broadcast',
  model_four: 'Offline',
  model_one_not_suffix: 'Instant',
  model_two_not_suffix: 'Schedule',
  model_three_not_suffix: 'Trigger',
  order_model: 'Sequential',
  random_model: 'Shuffle',
  cir_model: 'Loop',
  no_cir_model: 'No Loop',
  end: 'End',
  delete: 'Delete',
  volume: 'Volume',
  add: 'Add',
  batchDelete: 'Batch Delete',
  update: 'Edit',
  copy:'Copy',
  no_operate: 'Cannot be Operate',
  every: 'Every',
  week_one: 'Mon',
  week_two: 'Tue',
  week_three: 'Wed',
  week_four: 'Thu',
  week_five: 'Fri',
  week_six: 'Sat',
  week_seven: 'Sun',
  no_select_bro: 'Please select broadcast!',
  select_more_bro: 'Please select one!',
  has_unsupport_exten: 'Contains extensions that do not support offline',
  task_sync_complete: 'Sync Complete',
  task_sync_renew: 'Resynced',
  task_sync_fail: 'Sync failed',
  no_start_bro: 'Broadcast did not start!',
  delete_bro: 'Delete Broadcast?',
  /*broad form*/
  broadName: 'Broadcast Name',
  broadPriority: 'Broadcast Priority',
  broadPlayNum: 'Count Setting',
  broadPstn: 'Broadcast Access Number',
  broadTone: 'Pre-Broadcast Tone',
  broadAccessPw: 'Access Password',
  broadType: 'Broadcast Type',
  broadVolumn: 'Volume',
  broadOrder: 'Sort in Broadcast List',
  broadTime: 'Playback Duration',
  broadPlayQueue: 'Playback Playlist',
  musicQueue: 'Music Playlist',
  broadPlayType: 'Playback Mode',
  broadText: 'Text Content',
  broadUpdateFile: 'Update File',
  broadMusic: 'Music File',
  notice_content:'Notice Content',
  placeholderMusic: 'Please Select Music File',
  placeholderText: 'Please Select a txt File',
  placeholder_notice:'Please Input Notice Content',
  uploadMusic: 'Upload Music File',
  musicName: 'Music Name',
  musicPath: 'Music File',
  musicRemark: 'Music Remark',
  musicVolume: 'Music Volume',
  placeholderMusicName: 'Please Input Music Name',
  placeholderMusicPath: 'Please Upload Music File',
  placeholderMusicRemark: 'Please Input Music Remark',
  placeholderMusicVolume: 'Please Select Music Volume',
  placeholderOrder: 'Please Input Order',
  musicNameEmpty: 'Music Name Can`t be Empty',
  musicFileEmpty: 'Music File Can`t be Empty',
  musicVolumeEmpty: 'Music Volume Can`t be Empty',
  broadSee: 'Prerecord Terminal',
  broadFileType: 'Playback Type',
  placeholderBroadType: 'please Select Play Type',
  tts: 'Txt File',
  voice: 'Audio',
  txt_content: 'Txt Content',
  txt_file: 'Txt File',
  vioce_file: 'Voice File',
  broadTimeType: 'Scheduling Type',
  broadFixedTime: 'One-Time Schedule',
  broadWeekly: 'Weekly Repeat',
  /*form placeHolder*/
  bnameplaceHolder: 'Please Enter Name',
  bpriorityplaceHolder: 'Please Select Priority',
  bplayNumplaceHolder: 'Please Enter Times',
  bpstnplaceHolder: 'Please Select Access',
  btoneplaceHolder: 'Please Select Tone',
  baccessPwplaceHolder: 'Please Enter Access Pw',
  btypeplaceHolder: 'Please Select Type',
  btimeplaceHolder: 'Please Enter Time',
  bplayQueueplaceHolder: 'Please Select Queue',
  bplayTypeplaceHolder: 'Please Select Model',
  bseeplaceHolder: 'Please Select Control',
  buploadFileplaceHolder: 'Please Select File',
  btextplaceHolder: 'Please Enter Text',
  bfplaceHolder: 'Please Select Time',

  /*form validate*/
  name_vali: 'name can not be empty',
  priority_vali: 'priority can not be empty',
  play_times_vali: 'playback count can not be empty',
  lasting_time_vali: 'play time can not be empty',
  capture_dev_vali: 'capture can not be empty',
  access_num_vali: 'Connect Number can not be empty',
  prompt_tone_vali: 'prompt tone cant not be empty',
  access_num_pw_vali: 'access password can not be empty',
  temp_volume_vali: 'volume can not be empty',
  play_list_id_vali: 'play list can not be empty',
  play_music_idvali: 'Music can not be empty',
  playing_mode_vali: 'play mode can not be empty',
  text_content_vali: 'text can not be empty',
  file_vali: 'file can not be empty',
  exten_vali: 'Tips: devices can not be empty',
  authority_vali: '. Terminal out of authority cannot be operated',
  check_exten_vali: 'Please select the terminal device(s).',
  playing_time_vali: 'time can not be empty',
  broadcast_time_vali: 'time can not be empty',
  broadcast_effect_time_vali: 'effect time can not be empty',
  broadcast_weekday_time_vali: 'each weekday can not be empty',
  type_vali: 'type can not be empty',
  holiday: 'holiday',
  placeholderHoliday: 'Please Select Holiday',
  month: 'Month',
  date: 'Date',
  startTime: 'StartTime',
  endTime: 'EndTime',
  remark: 'Remark',
  operation: 'Operation',
  same_name_vali: 'broadcast name has already exist',
  exten_has_cross_time: 'extension has cross time',
  each_week: 'Each Week',
  effective_time: 'Effective Time',
  select_time: 'Select Time',
  terminal_file: 'Terminal File',
  offline_task: 'Offline Task',
  edit_volume: 'Edit Volume',
  task_asyc: 'Task Sync',
  update_volume: 'Update Volume',
  task_asys_detail: 'Task Sync Detail',
  broadcast_task: 'Broadcast Task',
  file_name: 'File Name',
  file_address: 'File Address',
  asyc_status: 'Sync Status',
  fail_reason: 'Fail Reason',
  retry: 'Retry',
  resend: 'Resend',
  force_delete: 'Force Delete',
  word: 'Word',
  whether_open: 'Enabled',
  has_open: 'yes',
  not_open: 'no',
  searchDevice: 'please input device number',
  b_number: 'Extension',
  b_name: 'Name',
  b_status: 'Status',
  b_volume: 'Volume',
  b_ip: 'IP',
  b_mac: 'MAC',
  b_type: 'Type',
  b_model: 'Mode',
  b_support_offline: 'Support Offline',
  support: 'YES',
  unsupport: 'NO',

  /**同步状态*/
  issuedStatus_0: 'Start Sync',
  issuedStatus_1: 'Syncing',
  issuedStatus_2: 'Synced',
  issuedStatus_3: 'Sync Fail',
  issuedStatus_4: 'Start Delete',
  issuedStatus_5: 'Deleting',
  issuedStatus_6: 'Delete Fail',

  /**失败原因*/
  failReason_1: 'Sent Fail',
  failReason_2: 'Response timeout',

  standGuard: 'Unattended Mode',
  transfer_phone: 'The Number For Call Forwarding',
  enterphone: 'Enter Unattended Phone',
  startStand: 'start unattended Mode',
  standing: 'Running Unattended Mode',
  cancel_stand: 'Stop unattended Mode',
  stand_error: 'Failed To Execute Unattended Mode',
  phone_error: 'phone error',
  warning: 'Alarm',
  device_alarm: 'Terminal Alarm',
  warning_type: 'Alarm Type',
  warning_unrelease: 'Active Alarms',
  warning_release: 'Cleared Alarms',
  warning_level: 'Alarm Level',
  warning_source: 'Alarm Source',
  warning_devName: 'Alarm Device Name',
  warning_status: 'Alarm Status',
  warning_happenTime: 'Alarm Occurrence Time',
  warning_releaseTime: 'Alarm Clearance Time',
  warning_remark: 'Alarm Notes',
  warning_sure: 'Acknowledge Alarm',
  warning_remove: 'Clear Alarm',
  warning_content: 'Alarm Content',
  level_one: 'Level One',
  level_two: 'Level Two',
  level_three: 'Level Three',
  status_one: 'New Alarm',
  status_two: 'Confirmed',
  status_three: 'Released',
  is_alarm: 'True Alarm',
  is_unalarm: 'False Alarm',
  no_sure_alarm: 'Alarm Not Confirmed',
  no_select_alarm: 'Please Select One Alarm!',
  ignore: 'Ignore',
  video: 'Video Surveillance',
  no_support_play: 'No Preview Available for that camera',
  camera: 'camera',
  reload: 'please reload camera',
  recording: 'Video Recording Started',
  stop_record: 'Video Recording Ended',
  img_record: 'Snapping Completed',
  image_look: 'Snapshot Records',
  video_look: 'Video Records',
  call_btn: 'Call Extension',
  image_record_btn: 'Screenshot',
  image_web_record_btn: 'Snapshot',
  video_record_start_btn: 'Start Recording',
  video_record_stop_btn: 'Stop Recording',
  ptz_btn: 'PTZ Control',
  close_btn: 'Close',
  stop_rtmp: 'Stop successful',
  view_image: 'View Image',
  view_video: 'View Video',
  image_name: 'Image Name',
  video_name: 'Video Name',
  create_date: 'Created Time',
  action: 'Action',
  view: 'View',
  playVideo: 'Play',
  download: 'Download',
  generator: 'Generate',
  hostInfo_tip: 'Generate HostInfo',
  hostInfo_content: 'This action will generate a new HostInfo to replace the old file.',
  no_camera: 'not select camera',
  message_live_scan: 'Scan Look',
  camera_no_active: 'Camera NO Active',
  camera_connected: 'Camera Connected Fail',
  no_free_windows: 'There is no free window. Do you want to replace the last open window?',
  line_limit: 'Number of video streams has reached its cap.',
  map: 'Digital Map',
  device: 'Extension',
  baidu_map: 'Map View',
  diy_map: 'Scenario View',
  edit_map: 'Map Edit',
  current_device: 'Current Extension',
  had_device: 'Terminal already existed in the map',
  del_device: 'Delete Terminal',
  upload_diy: 'Upload Picture',
  del_content: 'Map Deleting ',
  del_content_last: ' Extension',
  select_device: 'Please Select Extension In Map',
  unSelectExt: 'please select extension',
  unCheckExt: 'please check extension',
  checkOffLineExt: 'Please Select Support Offline Extension',
  unCheckOffLineExt: 'Please Check Support Offline Extension',
  reserve_plan: 'Response Preplan',
  reserve_plan_title:'Preplan',
  reporting_information: 'Submitted Report',
  execute_plan: 'Preplan executed or not',
  hasPlan: 'Preplan in place',
  delete_plan: 'Delete Preplan',
  no_select_plan: 'Please Select Preplan',
  select_more_plan: 'Please Select One Preplan!',
  plan_type: 'Preplan Type',
  all_plan: 'All Response Preplan',
  tamper_type: 'Tamper Alarm',
  oneKey_type: 'One-Key Alarm',
  waln_type: 'Gateway Alarm',
  device_empty: 'Terminal can not be empty',
  camera_empty: 'Camera can not be empty',
  trigger_one: 'Auto',
  trigger_two: 'Manual',
  trigger_three: 'Close',
  plan_device_name: 'Terminal/camera name',
  part_name: 'Part/Port',
  linkPlan: 'Linkage Preplan',
  haikang: 'HIKVISION',
  dahua: 'Dahua',
  sanli: 'King',
  fangwei: 'Fanvil',
  other: 'Other',
  alarm_type: 'Alarm Type',
  trigger_mode: 'Trigger Mode',
  alarm_type_placeHolder: 'Please Select Alarm Type',
  trigger_mode_placeHolder: 'Please Select Trigger Mode',
  placeholder_camera: 'Please Select Camera',
  plan_link_modal: 'Linkage Preplan',
  broad: 'Broadcast',
  sms: 'SMS',
  sms_phone: 'SMS Phone',
  sms_content: 'SMS Content',
  editable: 'SMS template can`t be blank.',
  camera_name: 'Camera Name',
  camera_brand: 'Brand',
  camera_address: 'IP Address',
  camera_port: 'IP Port',
  camera_initial_count: 'Account',
  exten_placeHolder: 'Please Enter Extension',
  queuing_notice: 'Notification',
  notice: 'Dispatch Notification',
  delete_notice: 'Delete Notice',
  notice_type: 'Notification Type',
  all_notice: 'All Notification',
  word_notice: 'Text Notification',
  record_notice: 'Record Notification',
  notice_access_num: 'Access No.',
  notice_display_num: 'Display No.',
  name: 'Name',
  notice_status: 'Status',
  notice_start_time: 'Start Time',
  notice_ttype: 'Type',
  notice_ntype: 'Way',
  notice_model: 'Model',
  notice_call_num: 'Call Plan',
  notice_called_num: 'Called',
  notice_uncall_num: 'Left',
  notice_volume: 'Volume',
  notice_call_pre: 'Called Rate',
  notice_uncall_pre: 'Not Called Rate',
  notice_accept_pre: 'Answer Rate',
  one_type: 'Instant Notification',
  two_type: 'Schedule Notification',
  three_type: 'Trigger Notification',
  detail: 'Detail',
  select_more_notice: 'Please Select One Notice',
  no_select_notice: 'Have not Select Notice',
  detail_modal: 'Detail Info',
  index: 'index',
  tel: 'Telephone',
  start_time: 'Start Time',
  ring_time: 'Ring Time',
  answer_time: 'Answer Time',
  hangup_time: 'Hangup Time',
  call_result: 'Call Result',
  send_result: 'Transmission Result',
  call_status: 'Call Status',
  call_count: 'Call Times',
  call_out: 'Number Called',
  call_answer: 'Customer Answered',
  call_hang: 'Customer Hung up',
  notice_name: 'Notification Name',
  retry_num: 'Retry Attempts',
  concurrency_num: 'Conc. Lines',
  concurrency_num_check: 'Conc. Lines Suggest filling in 1-9999',
  redial_times_check: 'Retries Suggest filling in 0-99',
  notice_access: 'Access Number',
  notice_access_pw: 'Access PIN',
  notice_display: 'Display Number',
  ring_times: 'Ringing Duration',
  sys_tel: 'Directory',
  file_tel: 'Import',
  file_tip: 'TXT file format required; phone numbers separated by commas (,).',
  record_file: 'Record File',
  notice_text: 'Notification Content',
  select_type: 'Number Selection Method',
  notice_tel: 'Selected Phone Numbers',
  tel_tip: 'Phone numbers separated by commas (,).',
  is_use: 'Enable',
  is_mpa: 'MP3 high quality',
  recv_btn: 'Key Press Confirmation',
  btn_val: 'Keyboard',
  notice_end: 'Button Confirmation Prompt Tone',
  endPlaceholder: 'Please Select Button Confirmation Prompt Tone',

  nnplaceholder: 'Please Enter Notification Name',
  nrplaceholder: 'Please Enter Retry Times',
  ncplaceholder: 'Please Enter ConCurrencies',
  naplaceholder: 'Please Select Access Number',
  ndplaceholder: 'Please Select Display',
  napplaceholder: 'Please Enter Access PIN Number',
  nrtplaceholder: 'Please Enter Ring Times',
  ntplaceholder: 'Please Select Notification Type',
  nrfplaceholder: 'Please select a recording file',
  ntcplaceholder: 'Please Enter The Notification Contents',
  ntsplaceholder: 'Please Enter the notification recipient’s phone number.',
  n_sms_vali: 'sms content can`t empty',
  n_name_vali: 'Name is can not be empty',
  n_retry_vali: 'Retry times is can not be empty',
  n_type_vali: 'Type is can not be empty',
  n_max_vali: 'Max Current number is can not be empty',
  n_pstn_vali: 'Access Number is can not be empty',
  n_pass_vali: 'Access PIN password is can not be empty',
  n_d_vali: 'Display is can not be empty',
  n_r_vali: 'Ring time is can not be empty',
  n_record_vali: 'Audio Record is can not be empty',
  n_text_vali: 'Text content is can not be empty',
  n_exten_vali: 'Notice mobiles is can not be empty',
  n_time_vali: 'Call time is can not be empty',
  n_week_vali: 'Call WeekTime is can not be empty',
  sys_ext: 'System Extension',
  address_book: 'Address Book',
  user_account: 'Account',
  agent_extension: 'Agent Extension',
  curr_time: 'Current Time',
  serverunconnected: 'server disconnected',
  serverconnected: 'server connected',
  contacts: 'Directory',
  linkman_group: 'Groups List',
  linkman_name: 'Contact Name',
  linkman_phone: 'Contact Number',
  linkman_groupname: 'Group Name',
  linkman_vip: 'VIP',
  linkman_remark: 'Remarks',
  linkman_self: 'Type',
  send: 'Send',
  sendMsg: 'Send Message',
  sendFilter: 'Send Filter',
  sendSelect: 'Send By Select',
  sendSearch: 'Send By Search',
  selecttemplate: 'SMS Template',
  sendData: 'Send Content',
  pleaseSelect: 'Please Select',
  pleaseInput: 'Please Enter',
  sendContentNull: 'Sent Content can’t empty',
  sendPhoneNull: 'Sent Phone can’t empty',
  sendFail: 'Sent Fail',
  sendSuccess: 'Sent Success',
  sendTypeNull: 'Sent Type can‘t empty',
  smsType: 'SMS Notification',
  notice_fun: 'Notification Method',
  voiceType: 'Voice Notification',
  smsAndVoiceType: 'Voice and SMS Notification',
  noAnswerSmsType: 'No Answer SMS Notification',
  all_link: 'All linkman',
  l_linkman_name_empty: 'name cannot be empty',
  l_link_phone_empty: 'phone cannot be empty',
  l_linkman_phone_empty: 'phone cannot be empty',
  l_group_empty: 'group cannot be empty',
  l_vip_empty: 'vip cannot be empty',
  l_link_group_name_empty: 'group name cannot be empty',
  l_link_group_name_exist: 'group name is exist',
  broad_link: 'Broad Link',
  video_link: 'Video Link',
  video_link_max: 'Number of Video linkage has reached its cap.',
  get_video: 'Error occurred in capturing video script address.',
  sms_link: 'SMS Linkage',
  no_svl: 'Please Select One Video Linkage',
  no_ssl: 'Please Select One SMS Linkage',
  broad_name_placeHolder: 'Please Select Broadcast',
  video_name_placeHolder: 'Please Select Camera',
  sms_phone_placeHolder: 'Please Enter SMS Phone',
  sms_content_placeHolder: 'Please Enter SMS Content',
  cameraname_placeHolder: 'Please Enter Camera Name',
  lname_placeHolder: 'Please Enter Contact Name',
  lphone_placeHolder: 'Please Enter Contact Number',
  lgroup_placeHolder: 'Please Select Group',
  lvip_placeHolder: 'Please Select',
  lremark_placeHolder: 'Please Enter Remark',
  select_more_link: 'Please Select One Contact',
  no_select_link: 'Please Select Contact',
  delete_linkman: 'Delete Contact',
  group: 'Group',
  group_btn: 'Manage Groups',
  group_manager: 'Contact Group Management',
  select_more_group: 'Select One Group',
  no_select_group: 'No Select Group',
  delete_group: 'Delete Group',
  delete_ginfo: '，and all contact in group.',
  lgname_placeHolder: 'Please Enter Group Name',
  no_link_phone: 'Contact No Number',
  link_phone_error: 'Contact Number Error',
  system: 'System Management',
  emergency: 'Emergency Broadcast',
  emergency_running:'Playing',
  edition_title: 'Visual Scheduling Platform',
  components: 'Components',
  count_to_page: 'Count-to',
  tables_page: 'Table',
  split_pane_page: 'Split-pane',
  markdown_page: 'Markdown-editor',
  editor_page: 'Rich-Text-Editor',
  icons_page: 'Custom-icon',
  img_cropper_page: 'Image-editor',
  doc: 'Document',
  join_page: 'QQ Group',
  update_table_page: 'Update .CSV',
  update_paste_page: 'Paste Table Data',
  multilevel: 'multilevel',
  directive_page: 'Directive',
  excel: 'Excel',
  'upload-excel': 'Upload Excel',
  'export-excel': 'Export Excel',
  tools_methods_page: 'Tools Methods',
  drag_list_page: 'Drag-list',
  i18n_page: 'Internationalization',
  modalTitle: 'Modal Title',
  content: 'This is the modal box content.',
  buttonText: 'Show Modal',
  'i18n-tip': 'Note: Only this page is multi-language, other pages do not add language content to the multi-language package.',
  error_store_page: 'Error Collection',
  error_logger_page: 'Error Logger',
  error: 'error',
  query: 'Query',
  params: 'Params',
  cropper_page: 'Cropper',
  message_page: 'Message Center',
  tree_table_page: 'Tree Table',
  org_tree_page: 'Org Tree',
  drag_drawer_page: 'Draggable Drawer',
  tree_select_page: 'Tree Selector',
  welcome: 'Welcome',
  out_full_screen: 'Out Full Screen',
  in_full_screen: 'Full Screen',
  fixConfGroup: 'Recurring Meeting',
  temConfGroup: 'Ad-hoc Meeting',
  invite: 'Invite',
  kick: 'Remove',
  mute: 'Mute',
  cmute: 'Unmute',
  allmute: 'Mute All',
  allcmute: 'Unmute All',
  cfstart: 'Start Conference',
  cfclose: 'Close',
  current_conferece: 'Current Conference',
  confNotOpen: 'Meeting not started yet.',
  confIsOpen: 'Meeting started.',
  callConfList: 'Meeting Info',
  confMember: 'Participants',
  EnterConference: 'Enter',
  LeaveConferce: 'Leave',
  MuteConference: 'Mute',
  CancelMuteConference: 'Unmute',
  inconf: 'In',
  Input_placeholder: 'Please Enter',
  highInfo: 'Advanced Settings',
  baseInfo: 'Basic Settings',
  KeyCollection: 'Key Setting',
  key_number: 'Key Presses',
  not_enter_number: 'Not Enter Number',
  call_lasting_time: 'Call Lasting Time',
  start_tip: 'Start Using Notice',
  notice_not_start_tip: 'Notification not launched yet. Do you want to launch it now?',
  broad_not_start_tip: 'Broadcast not launched yet. Do you want to launch it now?',
  /**************upload info **************/
  reporting_information_is_read: 'Read Status',
  reporting_information_upload_info: 'Message Report',
  reporting_information_all_info: 'All Submitted Info',
  reporting_information_has_read: 'Read',
  reporting_information_not_read: 'Unread',

  upInfo_col_index: 'Order',
  upInfo_col_id: 'Report ID',
  upInfo_col_title: 'Report Title',
  upInfo_col_content: 'Report Content',
  upInfo_col_isRead: 'Read Status',
  upInfo_col_upUserName: 'Submitted By',
  upInfo_col_address: 'Report Location',
  upInfo_col_file_path: 'Attachment',
  upInfo_col_upTime: 'Report Time',
  upInfo_col_file_comments: 'Comment',
  upInfo_col_baseInfo: 'Advanced Info',
  upInfo_col_open_comments: 'Unfold Comments',
  upInfo_col_close_comments: 'Fold Comments',
  upInfo_col_click_me: 'Click to open another link',
  upInfo_col_no_attach: 'No Attachment',
  upInfo_col_view_detail: 'Detail',
  upInfo_col_has_read: 'Read',
  upInfo_col_not_read: 'Unread',
  upInfo_col_not_support_preview: 'Preview Not Support',
  upInfo_col_modal_not_support_preview: 'No Preview Available for that file',


  upInfo_tip_add_success: 'Add Success',
  upInfo_tip_add_fail: 'Add Failure',
  upInfo_tip_update_success: 'Update Success',
  upInfo_tip_update_fail: 'Update Failure',
  upInfo_tip_select_one: 'Please select a line of information',
  upInfo_tip_enter_comment: 'Please enter comments',
  upInfo_tip_comment_not_blank: 'Comments cannot be empty',
  upInfo_tip_comment_last_editing: 'Please complete the previous comment.',

  upInfo_action_push: 'Push',
  upInfo_action_reset: 'Reset',
  upInfo_action_edit: 'Edit',

  display_more: 'More',
  /**显示更多下的菜单名指定(采用单个英文)**/
  more_menu_control: 'Console',
  more_menu_conference: 'Conference',
  more_menu_video_conference: 'Video Conference',
  more_menu_broadcast: 'Broadcast Task',
  more_menu_standGuard: 'Unattended Mode',
  more_menu_warning: 'Alarm Response Plan',
  more_menu_video: 'Video Surveillance',
  more_menu_map: 'Digital Map',
  more_menu_gis_map: 'GIS & Scene View',
  more_menu_dispatch: 'Dispatch Center',
  more_menu_channel: 'Channel Chat & Calls',
  more_menu_reserve_plan: 'Reserve',
  more_menu_queuing_notice: 'Notification',
  more_menu_contacts: 'Directory',
  more_menu_reporting_information: 'Submitted Report',
  more_menu_system: 'System Setting',

  // 菜单右击
  add_to_more: 'Add to more',
  move_forward: 'Move forward',
  move_back: 'Move back',
  remove_more: 'Remove more',
  remove_fail: 'Insufficient space, Removal failed',

  display_control: 'Display Terminals',
  system_theme: 'System Theme',
  outCallAutoAnswer:'External outgoing call auto answer',

  theme_black: 'black',
  theme_white: 'white',
  theme_blue: 'blue',
  language: 'System Language',
  system_version: 'System version',

  state_search: 'Status Filter',

  type_search: 'Type Filter',

  /* type filter */

  mode_phone: 'Phone',

  mode_speak: 'Intercom',

  mode_broad: 'Broadcast',

  mode_door: 'Door Access Controller',

  mode_pc: 'Service Desk',

  mode_car: 'Car Platform',

  mode_voice: 'Sound Mixer',

  mode_view: 'Video Terminal',

  mode_other: 'Other',
  sure_logout: 'Confirm Logout?',
  expire: 'Invalid license. Please contact the administrator or log in to the system management page to replace the license.',
  noLicense: 'No license. Please contact the administrator or log in to the system management page to replace the license.',
  license_warn:'The license is still valid for {day} days, please update it in a timely manner!',
  tamper_alarm: 'Tamper Alarm',
  one_alarm: 'One-Key Alarm',
  gateway_alarm: 'Gateway Alarm',
  motion_alarm: 'Motion Detection',
  helmet_alarm: 'Safety Helmet Alarm',

  please_select_device_dept: 'Please Select Device Dept',

  self_check: 'Self-Check Task',
  nowSelfCheck: 'Instant Self-Check',
  timerSelfCheck: 'Scheduled Self-Check',
  selfCheck_name: 'Name',
  selfCheck_status: 'Status',
  selfCheck_mode: 'Mode',
  selfCheck_cycle: 'Execution Cycle',
  selfCheck_playTime: 'Execution Time',
  selfCheck_all: 'Total',
  selfCheck_normals: 'Normal',
  selfCheck_abnormals: 'Abnormal',
  selfCheck_enable: 'enable',
  self_check_excute: 'Execute',
  self_check_result: 'Self-Check Result',
  self_check_time:'Self-Check Time',
  self_check_current_result: 'Current Result',
  self_check_history_result: 'History Result',
  no_select_self_check: 'please select self check task',
  self_check_update_title: 'Edit Self-Check Task',
  self_check_add_title: 'Add Self-Check Task',
  self_fixed_time: 'Fixed',
  self_cycle_time: 'Cycle',
  self_result_nostart: 'No Start',
  self_result_checking: 'Checking',
  self_result_normal: 'Normal',
  self_result_abnormal: 'Abnormal',
  self_fail_tip: 'Remark',
  self_result_uptime: 'EndTime',
  self_result: 'Result',
  self_name: 'Device Name',
  self_fail_device: 'Device Abnormal',
  self_fail_offline: 'Device Offline',
  self_fail_overtime: 'Over Time',
  self_fail_busy: 'Device Busy',
  self_check_exist: 'SelfCheck Task has exist',
  self_check_name: 'SelfCheck Task Name can`t empty',
  self_check_extens: 'SelfCheck Device can`t empty',
  self_check_deptId: 'Dept can`t empty',
  video_conference_no_limit: 'The number of video conference participants has reached the upper limit',


  //Notice

  system_notice: {
    title: {
      warn: 'data alert notification',
      delete: 'data deletion notification',
      selfCheck: 'Self-Check Exception',
      change: 'HA notification',
      alarm: 'Alarm plan notification'
    },
    turnToClean: 'click jump to clean up',
    turnToDetail: 'click to view details',
    turnToHA: 'Click to view ha status',
    self: {
      device: 'terminal',
      abnormal: 'exception'
    },
    operator: {
      backing: 'the system is backing up, please do not operate',
      reset: 'the system is being restored, please do not operate',
      reboot: 'the system is initializing, please do not operate',
      upgrade: 'the system is being upgraded, please do not operate',
    }
  },

  public: 'Public',
  self: 'Private',
  all_group: 'All Group',

  device_offline: 'Device No Online',
  no_broad_menu: 'No Broad Authority',
  dept: 'Group',
  conf: 'Conference',
  conf_link: 'Conference linkage',
  voice_conf_link: 'Voice Conference linkage',
  notice_link: 'Notification linkage',
  conf_name: 'Conference name',
  hourly_chime: 'Hourly Chime',
  hourly_chime_exits: 'The time reporting task already exists',
  cascade_manager: 'Cascade Management',
  chime_play_time: 'Execution time',
  chime_time_line: 'Broadcast Time Period',
  placeholderTimeLine: 'Please Select The Broadcast Time Period',
  chime_time_name: 'Time reporting task name cannot be empty',
  chime_time_terminal: 'Time reporting terminal cannot be empty',
  timeLineEmpty: 'Broadcast time period cannot be empty',
  no_select_chime_task: 'Please select time reporting task',
  chime_task: 'time reporting task',
  add_chime_task: 'Add Hourly Chime Task',
  update_chime_task: 'Update Hourly Chime Task',
  tips: 'Tips',
  only_number: 'Only numbers can be entered',
  page_count_overflow: 'Cannot exceed the current maximum page. The last page has been queried automatically',
  greater_than: 'greater than',
  less_than: 'less than',
  greater_than_or_equal: 'Greater or equal',
  less_than_or_equal: 'Less or equal',
  equal: 'equal',

  link_phone_tips: 'The contact number must be more than 7 before being invited in the fixed conference room',
  plan_has_no_link: 'Linkage is not added to the plan, please add linkage first',
  plan_has_link: 'Plan linkage already exists',
  jump_to: 'Jump to',
  page: 'page',
  app_login: 'Sorry! You are not a user of this system!',
  broadTimeAndCom: 'Duration Setting(minute)',
  no_system_menu: 'No System Management Authority',
  is_open: 'Enabled',
  is_closed: 'Disabled',
  start_plan: 'start plan',
  stop_plan: 'stop plan',
  dept_alarm: 'Activate Alarm',
  dept_clear: 'Deactivate Alarm',
  output_port: 'Output port',
  enter_manager: 'Enter management',
  show_all_child: 'Display all subordinate data',
  broad_overview: 'Broadcast overview',
  cascade_all: 'All Cascade',
  cascade_running: 'Playing',
  cascade_offline: 'Offline',
  cascade_text: 'Text',
  cascade_shout: 'Shouting',
  cascade_music: 'Music',
  cascade_timing: 'Timed',
  default_time: 'Default Time',
  no_default_time: 'Please select default time',
  employee_state: 'Terminal status',
  system_area: 'System area',
  change_fresh_time: 'Data Refresh',
  fresh_success: 'Refresh Success',
  fresh_fail: 'Refresh Fail',
  every_part: 'Refresh every',
  second_refresh: 'seconds',
  seconds: 'seconds',
  cascade_tip_one: 'The refresh interval of profile data in cascade management is 5 seconds by default',
  cascade_tip_two: 'When checked, the data of the selected and all its subordinate systems will be displayed',
  un_register: 'unregistered',
  add_broad: 'New Broadcast',
  select_bro: 'Select Broadcast',
  to_be_select_broad: 'Available Broadcasts',
  selected_broad: 'Selected Broadcasts',
  delete_broad_plan: 'Delete scheme?',
  enable_plan_tips: 'Only one scheme can be enabled in the system.<br/>Do you want to overwrite the currently enabled scheme?',
  plan_name_not_empty: 'name cannot be empty',
  select_holiday_time:'Please select the start date of the holiday',
  select_start_time: 'Please select the start time',
  select_end_time: 'Please select the end time',
  broad_day: 'Daily Repeat',
  every_day: 'Every Day',
  broad_not_enable: 'The current broadcast has been used by the following schemes. Please remove it and enable it again',
  broad_plan_not_delete: 'The current scheme has been used by scheme switching and cannot be deleted',
  broad_plan_not_enable: 'The current scheme has been used by scheme switching and cannot be enabled',
  time_have_same: 'There is an intersection between the current time and other data, please change the time',
  edit_not_enable: 'The current broadcast has been used by the following schemes and is disabled by default',
  not_null: ' Cannot be empty',
  start_big_end: 'The end time cannot be less than the start time',

  grade_register: 'system registered',
  grade_online: 'the system is not registered online',
  grade_offline: 'system offline',
  grade_main_system: 'main system',
  video_surveillance: 'Video Call Monitoring',
  plan_exist: 'Broadcast scheme already exists',
  broad_not_delete: 'The current broadcast has been used by the following schemes and cannot be deleted',
  current_video_call: 'Current Video Call',
  surveillance_video: 'Surveillance video',
  caller: 'Caller Number',
  callee: 'Callee Number',
  systemForCascade: 'System',

  already_exists: 'Already exists',
  sys_offline: 'The system is not online and no data is obtained',
  broad_cascade: 'Cascade broadcasting',
  delete_cascade: 'Cascade broadcasting will delete subsystem broadcasting. Do you want to continue?',
  outside_system: 'External system',
  add_cascade: 'There are offline systems in the selected extension tree that have not obtained extension data. Do you want to continue saving!',
  system_role: 'You do not have system management permission. Please contact the administrator to set role permissions',
  same_name_notice: 'Notification name already exists',
  content_too_long: 'Text content is too long',
  audio_not_support: 'The file does not support MP3 quality, please upload again',
  terminal_not_allowed: 'The acquisition and broadcast terminal is not allowed in the call terminal list',
  textType: 'Text Message Notification',
  out_of_authority: 'Out of authority',
  start: 'start',
  send_status: 'Send Status',
  text_is_too_long: 'Text content cannot exceed 500 byte',
  text_is_send: 'Text alerts sent cannot be edited',
  text_have_character: 'Text content is not allowed to contain \'|\'',
  text_have_content: 'Text content is not allowed to contain "content" in xml format',
  camera_foreach: 'Camera for Patrol',
  please_setting_camera: 'Please configure the patrol camera',
  enable_camera: 'Enable Camera Patrol',
  camera_time_interval: 'Patrol Interval (Seconds)',
  not_select_camera: 'Camera List',
  selected_camera: 'Selected Cameras',
  time_no_lg: 'The interval time cannot be less than 5 seconds',
  is_opening: 'Currently in patrol',
  is_not_two_page: 'The camera is less than two groups long, and the round robin automatically turns off',
  is_loading_data: 'Data loading, please wait',
  pause_robin: 'Pause',
  resume_robin: 'Resume',
  gateway_output: 'Gateway output',
  port_name: 'Port name',
  un_select_port: 'Please select a port',

  broad_mpa: '1. When the broadcast source file is higher than the 320kbps sampling rate, the broadcast voice file is played at the 320kbps sampling rate. When the source file is lower than the 320kbps sampling rate, the broadcast voice file is played at the actual sampling rate. \n' +
    '2. The selected terminal does not support MPA encoding and cannot connect to MP3 high-quality broadcast. \n' +
    '3. MP3 high quality broadcasting does not support broadcasting lower level cascading terminals. \n' +
    '4. MP3 high quality broadcasting does not support volume adjustment.\n' +
    '5. The music files uploaded before version 2.2.7 do not support MP3 high quality, and there will be no sound when they are opened.',
  video_isRecording: 'The video is recording, do you want to stop recording and close it?',
  camera_recording: 'The camera is recording',
  broad_start_file: ' Broadcasting began cue tone',
  no_quick_operate: 'Do not operate frequently',
  epx_name: 'EPX Management System',
  password_old_tip: 'For system security, please change the initial password of the system. Do you want to change it now?',
  system_tip: 'System prompt',
  modify_now: 'Modify Now',
  next_modification: 'Next modification',
  broad_user: 'Dispatcher',
  voice_meeting: 'Voice conference',
  video_meeting: 'Video conference',
  video_out_license: 'Video conferencing exceeds the member limit',
  upload_music_file: 'Upload a voice file',
  meeting: {
    record: {
      pre: 'Meeting Room:',
      stop: 'Stop recording',
      start: 'Start recording',
      not_stop: 'Recording cannot be closed',
    },
    content: {
      record: 'Video recording',
      nick: 'Nick',
      ip: 'IP'
    },
    warning: {
      in_room: 'You are already in the conference room：${roomName}！'
    },
    btn: {
      no_select: 'no select conference',
      setting: 'Settings',
      full: 'Full Screen',
      join: 'Join',
      leave: 'Quit',
      disableCamera: 'Disable camera',
      enableCamera: 'Enable camera',
    },
    setting: {
      camera: 'Camera',
      mic: 'Microphone',
      speak: 'Speaker',
      check:'Please check',
      permission:'permission'
    },
    right: {
      meeting: 'In Meeting',
      unMeeting: 'Not Joined'
    },
    invite: {
      title: 'Video Conference Invitation',
      content_pre: 'Dispatcher：',
      content_suf: '，inviting you to join the video conference：',
      join: 'Join',
      reject: 'Reject'
    },
    share: {
      info: 'screen sharing',
      start: 'Start sharing screen',
      end: 'End screen sharing',
      no_access: 'You do not have permission to end the sharing',
      sharing: 'Screen sharing in progress',
    }
  },
  gis_map: {
    map: {
      max_zoom: ' Map has been enlarged to maximum ',
      min_zoom: ' Map has been reduced to a minimum ',
      start_distance: ' Click on the map to start distance ',
      continue_distance: 'Click on the map to continue the distance or double click to end the distance ',
      continue_fence: 'Click on the map to continue drawing or double-click to end drawing',
      modify: ' Drag to modify ranging ',
      update_success: ' Update terminal location successful ',
      update_fail: ' Failed to update terminal location, please try again later! ',
      change_map: 'Please switch to the corresponding scene image！',
      add_success: ' Terminal added successfully ',
      add_exits: ' Failed to add terminal，terminal has be exits！',
      add_fail: ' Failed to add terminal, please try again later! ',
      delete_success: ' Delete terminal successfully ',
      delete_fail: ' Failed to delete the terminal, please try again later! ',
      load_fail: ' Failed to load terminal data, please try again later! ',
      upload_success: ' Upload scene image successfully ',
      upload_fail: ' Failed to upload scene diagram, please try again later! ',
      transfer_fail: 'Scene map conversion failed, please try again later! ',
      uploading: 'Uploading scene image',
      lng: 'Lng',
      lat: 'Lat',
      out_map: 'Please add in the scene diagram scope!',
      review: 'Reset',
      zoom_in: 'Zoom out',
      zoom_out: 'Zoom in',
      distance: 'Distance measurement',
      box_select: 'Box selection',
      circle_select: 'Circle',
      fence: 'Fence',
      upload: 'Upload'
    },
    app_select: {
      title: 'APP User',
      from_title: 'Available user',
      to_title: 'Selected user',
      search: 'Please enter keyword',
    },
    select: {
      title: 'Select terminal',
      current_pre: 'Current selection:',
      current_suf: 'terminal',
      voice_conf: 'Voice meet',
      video_conf: 'Video meet',
      multi_pro: 'Multi shouts ',
      multi_bro: 'Multi broad',
      batch_delete: 'Batch delete',
      no_selected: 'Unselected terminal',
      operation_selected: 'Please select the terminal that needs to be operated on！',
      not_support_delete: 'App terminal does not support deletion'
    },
    fence: {
      setting: {
        title: 'Fence Setup',
        name: 'Name',
        name_placeholder: 'Please enter fence name',
        time: 'Time',
        time_placeholder: 'Please select fence time range',
        remark: 'Remark',
        remark_placeholder: 'Please enter fence remarks',
        type: {
          no_enter: 'forbidden enter',
          no_leave: 'forbidden leave'
        },
        btn: {
          add: 'Add user',
          delete: 'Delete user',
          save: 'Save',
          cancel: 'Cancel'
        },
        columns: {
          name: 'name',
          number: 'number'
        },
        warn: {
          name: 'Fence name cannot be empty',
          start_time: 'Fence start time cannot be empty',
          end_time: 'Fence end time cannot be empty',
          edit: {
            success: 'Fence update success!',
            fail: 'Fence update failed, please try again later!',
            exits: 'Fence update failed, fence name has exits!'
          },
          point: 'Fence data cannot be empty',
          add: {
            success: 'Fence added successfully!',
            fail: 'Fence addition failed, please try again later!',
            exits: 'Fence addition failed, fence name has exits!'
          }
        }

      }
    },
    track: {
      play_title: 'Track playback',
      time: 'Time selection ',
      speed: 'Move speed',
      time_placeholder: 'Please select a time range',
      btn: {
        play: 'Play',
        pause: 'Pause',
        clear: 'Clear',
        query: 'Get trace'
      },
      detail_title: 'Track details',
      lat: 'Latitude',
      lng: 'Longitude',
      warn: 'Error in loading trajectory, please try again later!'
    },
    position: {
      title: ' Current location ',
      lng: 'Longitude :',
      lat: 'Latitude :',
      time: 'Time :'
    },
    overlay: {
      track: 'track',
      delete: 'delete'
    },
    search: {
      select: 'Please enter terminal name or extension number',
      fence: {
        title: 'Electronic fence',
        name: 'name',
        time: 'time',
        number: 'number of people',
        type: 'type',
        no_enter: 'forbidden enter',
        no_leave: 'forbidden leave',
        delete: {
          title: 'Remove fence',
          content: 'Confirm removal of fence :',
          ok: 'Confirm',
          cancel: 'Cancel',
          success: 'Fence removal successful!',
          fail: 'Fence removal failed, please try again later!'
        }
      },
      warn_content: 'Alarm record',
    },
    warn: {
      title: 'Alarm record',
      columns: {
        name: 'Fence name',
        type: 'Fence type',
        member: 'Member name',
        time: 'Alarm time'
      },
      enter: 'enter',
      leave: 'leave',
      tip_title: 'Fence warn',
      warn_prefix: 'Device：',
      warn_s: 'in time',
    }
  },
  deleteBroadFail: 'Broadcast has been used by linked tasks, deletion failed',
  member_info: 'Member Information',
  longitude: 'longitude',
  latitude: 'latitude',
  monitorOnly: 'monitor',
  appUser: 'APP',
  status: 'Status notification',
  status_tip:{
    status:'Status',
    device:'Device',
    time:'Time',
    content:'Content'
  },
  ext: 'Extension',
  online: 'Online',
  extOffline: 'Offline',
  meetingConf: 'Meeting',
  isLoading: 'Loading',
  control_search: 'Please Enter Number Or Name',
  last_play_time: 'Last Played Time',
  broad_log_columns: {
    name: 'Broadcast Name',
    play_time: 'Played Time',
    all_number: 'Number of Terminals',
    answer_number: 'Number of Answered Calls',
    callee_number: 'Number',
    callee_name: 'Name',
    answer_time: 'StartTime',
    is_answer: 'Answer',
    duration_time: 'Duration',
    hangup_reason: 'Hangup Reason',
    answer_state: 'Answer',
    no_answer_state: 'Not Answer',
    detail: 'Broadcast Log Detail'
  },
  hangup_reason: {
    user_busy: 'Agent Busy',
    523: 'Black List',
    524: 'Gateway offline or routing error',
    no_answer: 'No Answer',
    normal_clearing: 'Normal Clearing',
    no_user_response: 'No User Response',
    originator_cancel: 'Originator Cancel',
    db_error: 'DB Error',
    no_route_destination: 'No Route Destination',
    normal_unspecified: 'Normal Unspecified',
    call_rejected: 'Call Rejected',
    normal_temporary_failure: 'Normal Temporary Failure',
    200: 'Normal Hangup',
    fake_event: 'Fake Event',
    fake_event_reload: 'Fake Event Reload',
    unknown: 'Unknown',
    offline: 'Device Offline',
    manager_request: 'Exceeded daily call limit',
    outgoing_call_barred:'Reaching the call limit duration',
    other_answer:'Answered by someone else',
  },
  input_number: 'Enter the number',
  call_record: 'Call Monitoring',
  communication_dispatch: {
    link: 'Address Book',
    dispatch: 'Dispatching group',
    conf: 'Group Meeting',
    group: 'Group'
  },
  report: {
    menu: 'Report Management',
    left: {
      call_record: 'Call Records',
      audio_record: 'Recording Report',
      shout_image: 'Snapshot Records',
      alarm_record: 'Alarm Records',
      status_record: 'Status Records'
    },
    column: {
      call: {
        call_status: 'Call Type',
        caller_number: 'Caller Number',
        caller_name: 'Caller Name',
        called_number: 'Callee Number',
        called_name: 'Callee Name',
        start_time: 'Start Time',
        talk_status: 'Call Status',
        duration_time: 'Call Duration',
        rate: 'Rate',
        money: 'Money',
        hangup_reason: 'Hang-up Reason'
      },
      audio: {
        account_name: 'Account Name',
        start_time: 'Start Time',
        caller_number: 'Caller Number',
        caller_name: 'Caller Name',
        called_number: 'Called Number',
        called_name: 'Called Name'
      },
      shout: {
        name: 'Image Name',
        time: 'Snapshot Time',
        camera_name: 'Camera Name',
        device_name: 'Snapshot Terminal'
      },
      status:{
        device_name:'Device Name',
        exten:'Extension Number',
        device_type: 'Terminal Type',
        status:'Type',
        create_time:'Occurrence Time',
        register_ip:'Registered IP',
        register_port:'Port'
      },
      search: {
        call: {
          coming: 'Incoming Call',
          outing: 'Outgoing Call',
          inside: 'Internal Line',
          answer: 'Connected',
          no_answer: 'Not Connected'
        }
      }
    },
    btn: {
      export: 'Export',
      batch_download: 'Batch Download',
      batch_delete: 'Batch Delete',
      download_audio: 'Download Recording',
      play_audio: 'Play Recording',
      download_video: 'Download Video',
      play_video: 'Play Video',
      delete: 'Delete',
      download_image: 'Download Snapshot',
      view_image: 'View Snapshot',
    },
    filter: {
      label: 'Conditional',
      value1: 'Selection Result',
      value2: 'Search Result'
    },
    model: {
      title1: 'Export Record',
      title2: 'Batch Download',
      title3: 'Batch Delete',
      title4: 'Delete Record',
      title5: 'View',
      content1: 'Confirm deleting this recording？',
      title6: 'Delete Alarm Record',
      content2: 'Confirm deleting this recording？',
    },
    tip: {
      no_select: 'Please select data',
      no_data: 'No audio or video recording',
    },
    name: {
      broadcast: 'BroadCast Task',
      announce: 'Multi Announce',
      pagegroup: 'Page Group',
      conference: 'Conference'
    }
  },
  alarm_device: 'Alarm Terminal',
  yesterday: 'yesterday',
  channel: 'Channel',
  session: 'Session',
  please_input_name: 'Please enter the channel or session name',
  name_too_long:'The name is too long and needs to be within 20 characters',
  name_exits: 'The name already exists',
  chat_input_tip: 'Enter to send, Shift+Enter to wrap',
  please_input_info: 'Please enter the content to be sent',
  emoji: 'Emoji',
  img: 'Image',
  position: 'Position',
  select_member: 'Select members',
  current_member: ' members',
  please_select_mem: 'Please select a member',
  position_messages: 'Position messages',
  session_detail:'Session details',
  session_name:'Session name',
  delete_session:'Dissolve session',
  exit_session:'Exit session',
  delete_member:'Remove member',
  delete_member_tip:"Are you sure you want to remove it?",
  exit_session_tip:'Are you sure you want to exit the session?',
  delete_session_tip:'Dissolving the session will clear all records. Are you sure?',
  upload_fail:'Upload failed',
  img_upload_fail_tip:'File format error, please upload JPEG/PNG/JPG/GIF format image.',
  img_max_tip:'Exceeded image size limit, uploaded file cannot exceed ',
  audio_max_tip:'Exceeded voice size limit, file upload cannot exceed ',
  video_max_tip:'Exceeded video size limit, uploaded file cannot exceed ',
  file_max_tip:'Exceeded file size limit, uploaded file cannot exceed ',
  audio_type_error:'The file format is incorrect. Please upload the mp3/amr/mp4/format file.',
  add_member:'Add member',
  invite_members: 'Invite member',
  to_select_mem:"To be selected",
  selected_mem:"Selected",
  kick_member:"Moved out",
  member_leave:"Exited session",
  invite_member:"Invited",
  change_name: 'change the session name to',
  change_channel_name:'change the channel name to',
  create_session:'Create session',
  member_no_operate:'Member no change',
  member_over:'Members exceeding the 200 limit',
  channel_no_access:'No channel modification permission',
  no_member:'Please select member',
  system_user: 'System User',
  session_name_empty:'Session Name can`t empty',
  member_search_tip:'Please enter the member name or extension number',
  el:{
    transfer: {
      noMatch: 'No matching data',
      noData: 'No data',
      titles: ['List 1', 'List 2'], // to be translated
      filterPlaceholder: 'Enter keyword', // to be translated
      noCheckedFormat: '{total} items', // to be translated
      hasCheckedFormat: '{checked}/{total} checked' // to be translated
    },
  },
  quickButton:'Shortcut Buttons',
  quickBtn:'Button ',
  quickButtonSetting:'Quick key configuration',
  value:'Values',
  moveUp:'Move up',
  moveDown:'Move down',
  sureCall:'Are you sure to call',
  sureClick:'Are you sure to trigger',
  nullForQuickBtn:'The shortcut Button value is empty',
  defaultOpen:'Default Expand',
  access_pwd_be_number: 'The access no password must be a number',
  quick_btn_exits:'The shortcut key name already exists',
  first_one:'Moved to the front',
  last_one:'Moved to last',
  alarmTime:'Alarm time',
  queue_answer_error:'There is no need to interrupt the current call, please answer directly',
  queue_answer_left: 'Please answer the call on the phone',
  e_broad:{
    set_emergency: 'Config Emergency',
    config:'Config',
    no_emergency:'No Emergency Broadcast.',
    disabled: ' Disabled',
    enable:'Enabled',
    stop:'Disabled',
    access_pwd:'Password',
    selectOrInput:'Please input or select'
  },
  surveillance:{
    srsTip: 'Please complete the media server address configuration in the basic configuration before proceeding'
  },
  noticeDetails:'Notification record',
}



// WEBPACK FOOTER //
// ./src/locale/lang/en-US.js